import { useGlobalStore } from '@/store/global'
import { useRouter } from 'vue-router'
import { useMixError } from './useMixError'
import { computed } from 'vue'
import axios from 'axios'
import { toast } from "vue3-toastify";

export function useRoles() {
  const globalStore = useGlobalStore()
  const router = useRouter()
  const { showError } = useMixError()

  const isNotPdsUsers = computed(() => {
    const userName = globalStore.getAuthUser?.user?.name || ''
    const isPdsUserCheck = userName.toLowerCase().startsWith('pds_')
    return !(isPdsUserCheck)
  })

  const isPdsUser = computed(() => {
    return !isNotPdsUsers.value
  })

  function handleUnauthorizedAccess() {
    showError("No tiene acceso a este módulo")
    setTimeout(() => {
      logout()
    }, 2000)
  }

  function logout() {
    localStorage["loggedUser"] = false
    localStorage["merchantTags"] = null
    router.push('/login')
  }

  function closeBistroSessionAndRedirectToLogin() {
    toast.error('La sesión ha caducado, serás redirigido al login')
    setTimeout(() => {
      logout()
    }, 3000)
  }

  // Roles autorizados para ver Reportes BI.
  // Histórico: el composable solo permitía `Administrador`, lo que dejaba
  // afuera a usuarios con permisos de reportes legítimos (SalesReports) y a
  // testers, generando "No tiene acceso a este módulo" + logout al entrar.
  // Se alinea con `mixins/rolesCommons.vue` (legacy) que ya habilitaba estos
  // roles para el listado de reportes.
  const REPORTES_BI_ALLOWED_ROLES = ['Administrador', 'SalesReports', 'Tester']

  function hasToShowThisOption() {
    const roles = globalStore.getAuthUser?.roles || []
    return roles.some((r) => REPORTES_BI_ALLOWED_ROLES.includes(r))
  }

  async function checkSessionInBackendAsync() {
    try {
      const response = await axios.get('/api/auth/checkSession')

      if (response?.data?.responseCode < -1) {
        showError(response?.data?.responseMessage)
        return true
      }

      const isSessionOk = response?.data && response.data.responseCode === 0
      if (!isSessionOk) {
        if (response?.data?.responseCode === -1) {
          closeBistroSessionAndRedirectToLogin()
        }
      }

      return isSessionOk
    } catch (error) {
      console.error('Error checking session:', error)
      closeBistroSessionAndRedirectToLogin()
      return false
    }
  }

  return {
    isNotPdsUsers,
    isPdsUser,
    handleUnauthorizedAccess,
    logout,
    hasToShowThisOption,
    checkSessionInBackendAsync,
  }
}
